/* Loyalty Points — Birdie Shots */
(function() {
  const pointsEl = document.getElementById('nav-loyalty-points');
  if (!pointsEl) return;

  fetch('/apps/birdie-shots/api/loyalty/points')
    .then(r => r.json())
    .then(data => {
      if (data.points !== undefined) {
        pointsEl.textContent = data.points.toLocaleString();
      }
    })
    .catch(() => { pointsEl.textContent = '0'; });
})();
